<template>
    <div>
        <router-link class="d-flex align-items-center mb-3" :to="{'name': 'welcome'}">
            <img width=46 height=46 src="../../public/assets/logo/favicon.png"/>
            <span class="u-header__navbar-brand-text">RNeed</span>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "Logo"
    }
</script>

<style scoped>

</style>